import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice';
import booksReducer from './books/booksSlice';
import usersReducer from './users/usersSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    books: booksReducer,
    users: usersReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
